import {Component} from '@angular/core'
import {BaseComponent} from '../base.component'
import {MatFormField, MatHint, MatInput, MatLabel, MatSuffix} from '@angular/material/input'
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker'
import {FormsModule} from '@angular/forms'
import {provideDates} from '../../../application/app'

@Component({
  selector: 'spb-date-select',
  imports: [
    MatFormField,
    MatLabel,
    MatDatepickerInput,
    FormsModule,
    MatHint,
    MatDatepickerToggle,
    MatDatepicker,
    MatInput,
    MatSuffix
  ],
  templateUrl: './date-select.component.html',
  providers: [
    provideDates(),
    {provide: BaseComponent, useExisting: DateSelectComponent}]
})
export class DateSelectComponent extends BaseComponent {
  public override debugName = 'date-select'
}
